import { RadioTileGroup } from '@noissue-ui-kit/oldBranding/radioTile'
import { useEditorFullScreenMode } from '@pageFeatures/design/UnifiedEditorProvider'
import { HiOutlineAdjustments } from 'react-icons/hi'
import { useCurrentCanvasSide, useWidget } from '../EditorDataProvider'
import { PatternSettings } from './PatternSettings'
import { LogoSettings } from './LogoSettings'

export function CustomizeButton({
  showControls,
  setShowControls,
}: {
  showControls: boolean
  setShowControls: (boolean) => void
}) {
  const { canvasConfig } = useCurrentCanvasSide()
  const { isFullScreen } = useEditorFullScreenMode()
  const { widget } = useWidget('pattern')

  const radioTileButtonOption = {
    displayLabel: (
      <div className="flex items-center">
        <HiOutlineAdjustments className="w-[24px] h-[24px] mr-3" />
        <span className="font-semibold select-none">Customize</span>
      </div>
    ),
    key: 'customize',
  }

  return (
    <>
      <RadioTileGroup
        onChange={() => {
          if (canvasConfig.activeWidgetType) {
            setShowControls(!showControls)
          }
        }}
        options={[radioTileButtonOption]}
        radioGroupClassName={`grid-cols-1 w-full sm:w-auto grow ${
          isFullScreen && 'max-w-[200px]'
        }`}
        selected={
          showControls && canvasConfig.activeWidgetType
            ? { ...radioTileButtonOption }
            : null
        }
        radioItemClassName="hover:bg-black-10"
      />

      {showControls && canvasConfig.activeWidgetType === 'pattern' && (
        // For mobile view
        <div className="w-full sm:hidden">
          <PatternSettings patternVariant={widget?.config?.variant} />
        </div>
      )}

      {showControls && canvasConfig.activeWidgetType === 'logo' && (
        // For mobile view
        <div className="w-full sm:hidden">
          <LogoSettings />
        </div>
      )}
    </>
  )
}
